// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.legend-3-item {
  position: relative;
  border-radius: 50%;
  background-color: var(--indigo);
  width: 8px;
  height: 8px;
}

.radar-chart-container {
  position: relative;
  margin: 20px;
  height: 500px;
}

.radarchart1-title {
  display: flex;
  flex-direction: row;
  align-items: center;
  position: absolute;
  top: 380px;
  left: 160px;
  width: 868px;
  height: 38.5px;
  justify-content: space-between;
  text-align: left;
  font-size: var(--inter-34-sp-h4-size);
  color: var(--primary);
}

#radialbarchart {
  position: relative;
  width: fit-content;
  margin-left: auto;
  margin-right: 0px;
  display: flex;
  justify-content: center;
  max-width: 80%;
}

.amount19 {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: var(--gap-5xs);
}

.down-icon {
  position: relative;
  width: 1px;
  width: 20px;
  height: 20px;
  overflow: hidden;
  flex-shrink: 0;
}


.this-week1 {
  flex: 1 1;
  position: relative;
  letter-spacing: 0.22px;
  line-height: 22px;
  font-weight: 500;
}

.legend-color-box {
  display: inline-block;
  width: 12px;
  height: 12px;
  margin-right: 5px; /* Space between box and label */
}

.custom-legend {
  display: flex;
  align-items: center;
}

.uebersicht-page-container {
  display: flex;
  justify-content: flex-start; /* Align to the start of the container, which is left by default */
  align-items: center;
  height: 100%;
  width: 100%;
  padding-bottom: 10%;
  padding-left: 0%; /* Add padding to the left to move the table inward */
  font-family: 'Poppins', sans-serif; /* Apply the Poppins font */
  font-size: 12px;
}

/* Apply a bold font weight to all header cells in the table */
.rsuite-table .rs-table-header-cell-wrapper {
  font-weight: bold;
}


.cards {
  position: relative;
  border-radius: var(--br-xs);
  background-color: var(--white-base);
  border: 1px solid var(--border);
  display: flex;
  max-height: fit-content;
  padding: var(--padding-xl);
  margin: 0 20px; /* Adjusted margin to 20px on both sides */
}

.cards > * {
  margin-right: auto; /* Adjusted gap between children containers to 20px */
}

.cards > *:last-child {
  margin-right: 0; /* Remove the right margin for the last child to avoid extra spacing */
}

.cardcontent {
  position: relative;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  width: 250px;
}

.cardcontent-container{
  height: 100%;
  margin: 0px 20px;
}

.cardtitle {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  align-self: stretch;
  height: 100%;
  justify-content: space-between;
  position: relative;
  display: flex;
  flex-direction: row;
  width: 100%;
  height: fit-content;
  align-items: flex-start;
}

.cardTitleNumber{
  font-family: Inter;
  font-size: 28px;
  font-style: normal;
  font-weight: 700;
  line-height: 36px;
}

.cardTitleText {
  height: 50px;
  overflow: hidden;

  /* TEXT FONT */
  font-family: Inter;
  font-size: calc(16px + 2 * ((100vw - 1650px) / 200));
  font-style: normal;
  font-weight: 700;
  line-height: 24px; /* 150% */
  letter-spacing: 0.12px;
}

.cardIconContainer {
  position: absolute;
  right: 0;
  top: 50%;
  width: auto;
  height: auto;
  transform: translateY(-50%);
}

.cardIcon{
  width: 100%;
  height: 32px;
}


.cardinfo {
  position: relative;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  align-self: stretch;
  flex-direction: row;
  font-size: var(--mini-button-label-size);

  /* TEXT FONT */
  color: var(--secondary);
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px; /* 157.143% */
  letter-spacing: 0.22px;
}

/* Add margin to all children except the last one */
.cardinfo > * {
  margin-right: 8px; /* Adjust the value as needed */
}

.divider1 {
  position: relative;
  border-right: 1px solid var(--border);
  box-sizing: border-box;
  width: 1px;
}`, "",{"version":3,"sources":["webpack://./src/widgets/UebersichtWidgets.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,+BAA+B;EAC/B,UAAU;EACV,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,cAAc;EACd,8BAA8B;EAC9B,gBAAgB;EAChB,qCAAqC;EACrC,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,cAAc;AAChB;;;AAGA;EACE,SAAO;EACP,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,iBAAiB,EAAE,gCAAgC;AACrD;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2BAA2B,EAAE,kEAAkE;EAC/F,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,gBAAgB,EAAE,qDAAqD;EACvE,kCAAkC,EAAE,2BAA2B;EAC/D,eAAe;AACjB;;AAEA,8DAA8D;AAC9D;EACE,iBAAiB;AACnB;;;AAGA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,mCAAmC;EACnC,+BAA+B;EAC/B,aAAa;EACb,uBAAuB;EACvB,0BAA0B;EAC1B,cAAc,EAAE,0CAA0C;AAC5D;;AAEA;EACE,kBAAkB,EAAE,qDAAqD;AAC3E;;AAEA;EACE,eAAe,EAAE,sEAAsE;AACzF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,2BAA2B;EAC3B,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,8BAA8B;EAC9B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,gBAAgB;;EAEhB,cAAc;EACd,kBAAkB;EAClB,oDAAoD;EACpD,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;EAC5B,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;;AAGA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,2BAA2B;EAC3B,mBAAmB;EACnB,mBAAmB;EACnB,wCAAwC;;EAExC,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;EAChC,sBAAsB;AACxB;;AAEA,mDAAmD;AACnD;EACE,iBAAiB,EAAE,+BAA+B;AACpD;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,sBAAsB;EACtB,UAAU;AACZ","sourcesContent":[".legend-3-item {\r\n  position: relative;\r\n  border-radius: 50%;\r\n  background-color: var(--indigo);\r\n  width: 8px;\r\n  height: 8px;\r\n}\r\n\r\n.radar-chart-container {\r\n  position: relative;\r\n  margin: 20px;\r\n  height: 500px;\r\n}\r\n\r\n.radarchart1-title {\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-items: center;\r\n  position: absolute;\r\n  top: 380px;\r\n  left: 160px;\r\n  width: 868px;\r\n  height: 38.5px;\r\n  justify-content: space-between;\r\n  text-align: left;\r\n  font-size: var(--inter-34-sp-h4-size);\r\n  color: var(--primary);\r\n}\r\n\r\n#radialbarchart {\r\n  position: relative;\r\n  width: fit-content;\r\n  margin-left: auto;\r\n  margin-right: 0px;\r\n  display: flex;\r\n  justify-content: center;\r\n  max-width: 80%;\r\n}\r\n\r\n.amount19 {\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-items: center;\r\n  justify-content: flex-start;\r\n  gap: var(--gap-5xs);\r\n}\r\n\r\n.down-icon {\r\n  position: relative;\r\n  width: 1px;\r\n  width: 20px;\r\n  height: 20px;\r\n  overflow: hidden;\r\n  flex-shrink: 0;\r\n}\r\n\r\n\r\n.this-week1 {\r\n  flex: 1;\r\n  position: relative;\r\n  letter-spacing: 0.22px;\r\n  line-height: 22px;\r\n  font-weight: 500;\r\n}\r\n\r\n.legend-color-box {\r\n  display: inline-block;\r\n  width: 12px;\r\n  height: 12px;\r\n  margin-right: 5px; /* Space between box and label */\r\n}\r\n\r\n.custom-legend {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.uebersicht-page-container {\r\n  display: flex;\r\n  justify-content: flex-start; /* Align to the start of the container, which is left by default */\r\n  align-items: center;\r\n  height: 100%;\r\n  width: 100%;\r\n  padding-bottom: 10%;\r\n  padding-left: 0%; /* Add padding to the left to move the table inward */\r\n  font-family: 'Poppins', sans-serif; /* Apply the Poppins font */\r\n  font-size: 12px;\r\n}\r\n\r\n/* Apply a bold font weight to all header cells in the table */\r\n.rsuite-table .rs-table-header-cell-wrapper {\r\n  font-weight: bold;\r\n}\r\n\r\n\r\n.cards {\r\n  position: relative;\r\n  border-radius: var(--br-xs);\r\n  background-color: var(--white-base);\r\n  border: 1px solid var(--border);\r\n  display: flex;\r\n  max-height: fit-content;\r\n  padding: var(--padding-xl);\r\n  margin: 0 20px; /* Adjusted margin to 20px on both sides */\r\n}\r\n\r\n.cards > * {\r\n  margin-right: auto; /* Adjusted gap between children containers to 20px */\r\n}\r\n\r\n.cards > *:last-child {\r\n  margin-right: 0; /* Remove the right margin for the last child to avoid extra spacing */\r\n}\r\n\r\n.cardcontent {\r\n  position: relative;\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: flex-start;\r\n  flex-direction: column;\r\n  width: 250px;\r\n}\r\n\r\n.cardcontent-container{\r\n  height: 100%;\r\n  margin: 0px 20px;\r\n}\r\n\r\n.cardtitle {\r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-items: flex-start;\r\n  align-self: stretch;\r\n  height: 100%;\r\n  justify-content: space-between;\r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: row;\r\n  width: 100%;\r\n  height: fit-content;\r\n  align-items: flex-start;\r\n}\r\n\r\n.cardTitleNumber{\r\n  font-family: Inter;\r\n  font-size: 28px;\r\n  font-style: normal;\r\n  font-weight: 700;\r\n  line-height: 36px;\r\n}\r\n\r\n.cardTitleText {\r\n  height: 50px;\r\n  overflow: hidden;\r\n\r\n  /* TEXT FONT */\r\n  font-family: Inter;\r\n  font-size: calc(16px + 2 * ((100vw - 1650px) / 200));\r\n  font-style: normal;\r\n  font-weight: 700;\r\n  line-height: 24px; /* 150% */\r\n  letter-spacing: 0.12px;\r\n}\r\n\r\n.cardIconContainer {\r\n  position: absolute;\r\n  right: 0;\r\n  top: 50%;\r\n  width: auto;\r\n  height: auto;\r\n  transform: translateY(-50%);\r\n}\r\n\r\n.cardIcon{\r\n  width: 100%;\r\n  height: 32px;\r\n}\r\n\r\n\r\n.cardinfo {\r\n  position: relative;\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: flex-start;\r\n  align-self: stretch;\r\n  flex-direction: row;\r\n  font-size: var(--mini-button-label-size);\r\n\r\n  /* TEXT FONT */\r\n  color: var(--secondary);\r\n  font-family: Inter;\r\n  font-size: 12px;\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  line-height: 22px; /* 157.143% */\r\n  letter-spacing: 0.22px;\r\n}\r\n\r\n/* Add margin to all children except the last one */\r\n.cardinfo > * {\r\n  margin-right: 8px; /* Adjust the value as needed */\r\n}\r\n\r\n.divider1 {\r\n  position: relative;\r\n  border-right: 1px solid var(--border);\r\n  box-sizing: border-box;\r\n  width: 1px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
